import cn from 'classnames';
import { ComponentCommonTextEditorWithHtml } from '..';

function cleanParagraphBrTags(html: string): string {
  return html
    .replace(new RegExp('&nbsp;', 'g'), ' ')
    .replace(new RegExp('(<p[^>]*>)\\s*(<br\\s*/?>\\s*)+', 'gi'), '$1')
    .replace(new RegExp('(<br\\s*/?>\\s*)+</p>', 'gi'), '</p>');
}

function removeInlineFontStyles(html: string): string {
  return html.replace(/style="([^"]*)"/gi, (_match, styles) => {
    const cleanedStyles = styles
      .split(';')
      .filter((style: string) => {
        const trimmed = style.trim();
        return !trimmed.toLowerCase().startsWith('font-family') && !trimmed.toLowerCase().startsWith('font-family:');
      })
      .join(';');
    return cleanedStyles ? `style="${cleanedStyles}"` : '';
  });
}

export default function DefaultContentTemplateTextEditor({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonTextEditorWithHtml;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  let markdown = cleanParagraphBrTags(component.markdownText || '');
  markdown = removeInlineFontStyles(markdown);

  return (
    <div
      key={markdown}
      className={cn(
        'default-content-template-text-editor overflow-auto whitespace-pre-wrap text-dark-grey',
        className,
        {
          'my-0': isDefaultContentTemplate,
          'my-sh-30': !isDefaultContentTemplate,
        },
      )}
      dangerouslySetInnerHTML={{
        __html: markdown || '',
      }}
    />
  );
}
